var exports = {
  "OD": "codeAlert__SEH3B9",
  "mj": "codeAlertCentered__P4UJul",
  "Qb": "codeAlertRight__r9QU5s",
  "cD": "codeFoldingChevron__VrFPse",
};

module.exports = exports;
